import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";
import {DeleteRecordButton} from "../buttons/DeleteRecordButton.tsx";
import {AddRecordButton} from "../buttons/AddRecordButton.tsx";
import {MeteringRecord} from '../types';

interface IndexPageHeaderProps {
    selectedRecords: MeteringRecord[];
    setSelectedRecords: (records: MeteringRecord[]) => void;
}

const useTools = (selectedRecords: MeteringRecord[], setSelectedRecords: (records: MeteringRecord[]) => void) => {

    const {allowedActions} = useVerifiedPermissions();

    const tools = [];

    tools.push(<ReloadRecordsButton key='reload'/>);

    if (allowedActions.includes('DeleteMeteringRecord')) {
        tools.push(<DeleteRecordButton key='delete' selectedRecords={selectedRecords}
                                       setSelectedRecords={setSelectedRecords}/>);
    }

    if (allowedActions.includes('CreateMeteringRecord')) {
        tools.push(<AddRecordButton key='add'/>);
    }

    return tools;
};

export const IndexPageHeader = ({selectedRecords, setSelectedRecords}: IndexPageHeaderProps) => {
    return (
        <SimplePageHeader
            title={I18n.get('Metering Records')}
            tools={useTools(selectedRecords, setSelectedRecords)}
        />
    );
};
